import { useState, useEffect } from 'react';
import { posService } from '@/services/pos.service';

interface Category {
  id: string;
  name: string;
  label: string;
  icon?: string;
}

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadCategories = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await posService.getCategories();
      
      if (response.success) {
        // Convertir IDs a string para asegurar consistencia
        const categoriesWithStringIds = response.data.map(category => ({
          ...category,
          id: String(category.id)
        }));

        setCategories(categoriesWithStringIds);
      } else {
        throw new Error('Error al cargar categorías');
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Error desconocido');
      console.error('Error loading categories:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return {
    categories,
    loading,
    error,
    refetch: loadCategories
  };
};